import { useContext, useEffect, useState } from "react";
import { VendorItemDto } from "../../../../dtos/catalogs/vendoritem/VendorItemDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import VendorItemDetailSkeleton from "./VendorItemDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import VendorItemDetailMain from "./VendorItemDetailMain";

interface IProps {
  model: VendorItemDto | null;
  modelUpdatedEvent: (newModel: VendorItemDto) => void;
}

interface VendorItemModel {
  id: string;
  name: string;
  createdDate?: Date;
  description?: string;
  vendorID?: string;
  vendorParentId?: string;
  productId?: string;
  vendorUnitId?: string;
  productUnitId?: string;
}

export const VendorItemDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<VendorItemModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("createdDate", model.createdDate);
      setValue("description", model.description);
      setValue("vendorID", model.vendorID);
      setValue("vendorParentId", model.vendorParentId);
      setValue("productId", model.productId);
      setValue("vendorUnitId", model.vendorUnitId);
      setValue("productUnitId", model.productUnitId);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: VendorItemModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: VendorItemDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <VendorItemDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Settings"} />
        </NFTabs>
        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <VendorItemDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
